import React from 'react';
import styled from 'styled-components';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
const SectionTitle = styled.h2 `
    font-size: ${(props) => props.theme.fonts.textSizeH2};
    font-weight: 500;
`;
const SectionTitleViewer = ({ componentValues }) => {
    const { title } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const renderTitle = () => {
        if (title) {
            return React.createElement(SectionTitle, null, title);
        }
        return null;
    };
    return React.createElement(ViewerErrorBoundary, null, renderTitle());
};
export default SectionTitleViewer;
//# sourceMappingURL=index.js.map